import React, { FC } from 'react';
import { getFormattedDate, getFormattedUTCDate } from '../utils/utilities';
import clsx from 'clsx';
import { WhisperComponent } from './developers/page-components/WhisperComponent';
import { Title } from './developers/page-components/Title';
import moment from 'moment-timezone';
import { TypeAttributes } from 'rsuite/cjs/internals/types';

interface Props {
	value: string;
	isTime?: boolean;
	additionalContainerClass?: string;
	additionalDateClass?: string;
	additionalTimeClass?: string;
	isTooltip?: boolean;
	placement?: TypeAttributes.Placement;
}

export const DateComponent: FC<Props> = (props) => {
	const { value, isTime, additionalContainerClass, additionalDateClass, additionalTimeClass, isTooltip, placement = 'auto' } = props;
	const year = new Date(value)?.getFullYear();
	if (!value || year === 1 ) {
		return <div className="fw-bolder">-</div>;
	}

	const date = (
		<div className={additionalContainerClass}>
			<div className={clsx(additionalDateClass ? additionalDateClass : 'fs-8')}>
				{getFormattedDate(value, 'dd MMM, yyyy')}
			</div>
			{isTime && (
				<div className={clsx(additionalTimeClass ? additionalTimeClass : 'fs-8')}>
					{getFormattedDate(value, 'hh:mm a')}
				</div>
			)}
		</div>
	);

	const date1 = new Date();
	const timeZoneAbbreviation = moment.tz(date1, moment.tz.guess()).zoneAbbr();

	const speaker = (value): JSX.Element => {
		return (
			<div>
				<Title title="Time conversion" additionalClass="fw-bolder pb-2" />
				<div className="separator" />
				<div className="d-flex align-items-center justify-content-between w300px py-2">
					<div className="w-120px">UTC</div>
					<div>
						{getFormattedUTCDate(value, 'hh:mm a')}
					</div>
					<div>
						{getFormattedUTCDate(value, 'dd MMM, yyyy')}
					</div>
				</div>

				<div className="separator" />

				<div className="d-flex align-items-center justify-content-between w-300px pt-2">
					<div className="w-120px">
						{timeZoneAbbreviation} - Your computer
					</div>
					<div>
						{getFormattedDate(value, 'hh:mm a')}
					</div>
					<div>
						{getFormattedDate(value, 'dd MMM, yyyy')}
					</div>
				</div>
			</div>
		);
	};


	return (
		<>
			{
				isTooltip
					? (
						<WhisperComponent
							whisperText={speaker(value)}
							mainText={date}
							placement={placement}
							additionalClass="fc-text-overflow d-block"
						/>
					) : date
			}
		</>
	);
};